import React from 'react';
import {withStyles} from 'material-ui/styles/index';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';

const styles = theme => ({
    root    : {
        display   : 'flex',
        alignItems: 'center'
    },
    logo    : {},
    logoIcon: {
        width : 38,
        height: 38
    }
});

function MainNavbarHeader({classes})
{
    return (
        <div className={classes.root}>
            <div className={classNames(classes.logo, "flex items-center")}>
                {/* <img className={classes.logoIcon} src="assets/images/logos/H2.png" alt="logo"/>
                <Typography className="text-20 ml-8 font-light logo-text"></Typography> */}
                <div
                    className="react-badge flex items-center ml-12 py-4 px-8 rounded"
                    style={{
                        // backgroundColor: 'rgba(0,0,0,0.6)',
                        // color          : '#61dafb'
                    }}
                >
                    <img
                        className="react-logo"
                        src="assets/images/backgrounds/IMC Logo1.png"
                        alt="react"
                        width="90%"
                    />
                </div>
            </div>
        </div>
    );
};

export default withStyles(styles, {withTheme: true})(withRouter(MainNavbarHeader));



// WEBPACK FOOTER //
// ./src/main/MainNavbarHeader.js